import type { BouncySumsQuestion } from '@/features/bouncySums/types';

export class BouncySumsQuestionGenerator {
	private currentList: BouncySumsQuestion[] = [];
	private fullList: BouncySumsQuestion[] = [];
	private wrongQuestions: BouncySumsQuestion[] = [];
	private wrongQuestionQueuedForCurrentQuestionId: string | null = null;

	loadQuestions(questions: BouncySumsQuestion[]) {
		this.fullList = [...questions];
		this.currentList = [...this.fullList];
		this.wrongQuestions = [];
		this.wrongQuestionQueuedForCurrentQuestionId = null;
	}

	answeredIncorrect(question: BouncySumsQuestion) {
		if (this.wrongQuestionQueuedForCurrentQuestionId === question.id) {
			return;
		}

		this.wrongQuestionQueuedForCurrentQuestionId = question.id;
		this.wrongQuestions.push(question);
	}

	getQuestion() {
		if (this.currentList.length === 0 && this.wrongQuestions.length > 0) {
			return this.useQuestion(this.wrongQuestions.shift() as BouncySumsQuestion);
		}

		if (this.currentList.length === 0) {
			this.currentList = [...this.fullList];
		}

		if (this.currentList.length === 0) {
			throw new Error('Bouncy Sums requires at least one question.');
		}

		const questionIndex = Math.floor(Math.random() * this.currentList.length);
		const [question] = this.currentList.splice(questionIndex, 1);

		return this.useQuestion(question);
	}

	private useQuestion(question: BouncySumsQuestion) {
		this.wrongQuestionQueuedForCurrentQuestionId = null;

		return question;
	}
}
